import {
    TOTAL_USERS,
} from "../constants/elementConst";
import {renderIfTrue} from "../features/tools";
import sortTemplate from "./sort";
import store from '../store';

export default function(){
    const userData = store.get("userList");
    const totalCount = store.get("totalCount");

    return `
        ${renderIfTrue(!store.get("noInitUsers"), () => `
            <header class="employee_register__helpers employee_register--mx-40 employee_register--mb-10">
                <span>
                    <span class="employee_register__text--bold" data-js="${TOTAL_USERS}">
                       ${userData.length} av ${totalCount}
                    </span>
                    treff
                </span>
                
                ${sortTemplate()}
            </header>
        `)}
    `
}